// extracted by mini-css-extract-plugin
export default {"milestone":"PredictedMilestoneCell_milestone__iL9A1"};